var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFooter)?_c('div',[_c('GrowBottomNavigation',{style:(this.$i18n.locale == 'en' ? 'direction:ltr !important' : 'direction:rtl !important'),attrs:{"options":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }